<template>
	<div class="financial-warning">
		<v-tooltip bottom>
			<template v-slot:activator="{ on }">
				<v-icon color="warning" v-on="on" class="ml-1">
					warning
				</v-icon>
			</template>
			<span>Faktycznie poniesione wydatki są większe niż kwota z umowy</span>
		</v-tooltip>
	</div>
</template>

<script>
	export default {
		name: "FinancialTableCostHeadersWarning"
	};
</script>

<style scoped>
@media print {
	.financial-warning >>> .v-icon {
		color: grey !important;
	}
}
</style>
